module.exports = __webpack_public_path__ + "static/2-6d3b14447af08156025919d58072662b.svg";